
<template>
  <!--物业账号管理-->
  <div>
    <x-tabula
      v-if="reload"
      ref="table"
      :dataSource="dataSource"
      rowKey="userId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="[]"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    <template slot="bread">
      <a-breadcrumb style="margin-bottom: 20px;">
        当前位置:
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item, index) in breadList" :key="index">
          <a href="javascript:;" @click="handleBread(index)">{{item}}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </template>
    </x-tabula>
    <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel">
      <a-radio default-checked :disabled="false" v-if="title === '设为主账号'">
        <span>替换原主账号:</span>
        <div style="margin-left: 22px">与原主账号的分管区域和角色互换</div>
      </a-radio>
      <div v-else-if="title === '账号转移'" class="select-wrap">
        <div>
          选择主账号:
          <a-select placeholder="公司名(账号名)" :allowClear="true" showSearch :filter-option="filterOption" option-filter-prop="children" size='large' style="width: 200px;margin-left:8px;" @change="handleChangeSin">
            <a-select-option :value="item.value" v-for="(item, index) of accountList" :key="index">
              <a-tooltip placement="top" :title="item.label" arrow-point-at-center>
                {{item.label}}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div class="select-box">
          选择角色:
          <a-select v-model="roleValue" mode="multiple" placeholder="请选择角色" showSearch :filter-option="filterOption" option-filter-prop="children"  size='large' style="width: 200px;margin-left:8px;" @change="handleChangeDou" @deselect="handleDeselect">
            <a-select-option :value="item.value" v-for="item in roleList" :key="item">
              {{item.label}}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'propertyAccount',
  data () {
    return {
      reload: true,
      breadList: ['物业账号'],
      currentRow: {},
      title: '设为主账号',
      confirmLoading: false,
      visible: false,
      accountList: [],
      roleList: [],
      roleValue: [],
      formKey: {
        parentId: '',
        roleId: ''
      },
      searchList: [
        { label: '', props: ['keywords'], placeholder: '公司、账号名、手机号', inputType: 'input' },
        { label: '', props: ['roleId'], placeholder: '角色', options: [], inputType: 'select' },
        { label: '', props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: '',
        roleId: '',
        createDate: ''
      },
      columns: [
        { title: '账号名', dataIndex: 'userName', align: 'left', width: '' },
        { title: '手机', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '姓名', dataIndex: 'trueName', align: 'left', width: '' },
        { title: '角色', dataIndex: 'roleName', align: 'left', width: '' },
        { title: '公司名', dataIndex: 'propertyName', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createDateStr', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      rowOptList: [
        // { text: '重置密码', handle: (row) => this.resetPwd(row.userId), key: 'resetPwd' },
        { text: '修改', handle: (row) => this.$refs.table.toEdit(row), permi: ['community:propertyAccount:edit'] },
        {
          text: '',
          rowOptText: row => row.newViewAuth === 0 ? '可视1.0' : '可视2.0',
          handle: row => this.triggerViewAuth(row),
          customRender: true,
          permi: ['community:propertyAccount:view']
        },
        {text: '查看下级', handle: row => this.toSubordinate(row), permi: ['community:propertyAccount:child']}
      ],
      childRowOptList: [
        // { text: '重置密码', handle: (row) => this.resetPwd(row.userId), key: 'resetPwd' },
        {text: '设为主账号', handle: (row) => this.setOwnAccount(row), permi: ['community:propertyAccount:primary']},
        {text: '账号转移', handle: (row) => this.accountTransfer(row), permi: ['community:propertyAccount:transfer']}
      ],
      dataSource: [],
      listApi: {
        url: '/property/user/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'editPropertyAccount',
        title: '编辑物业账号'
      },
      deleteParam: {
        url: '/property/user/list',
        param: { pk_key: 'userId', pk_val: '' },

        title: '物业账号',
        key: 'userName'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.propertyManageSelect([{index: 1}]);
    },
    /** 切换可视化版本权限 */
    triggerViewAuth (row) {
      this.$put({
        url: `/property/user/changeViewAuth/${row.userId}`,
        params: { viewAuth: row.newViewAuth ? 0 : 1 }
      }).then(({data}) => {
        this.$message.success('切换成功');
        this.$refs.table.getTableList();
      });
    },
    /* 密码重置 */
    resetPwd (id) {
      this.$post({
        url: '/property/user/reset_password',
        params: { userId: id }
      }).then((res) => {
        this.$message.success('密码重置成功！');
      });
    },
    // 查看下级账号
    toSubordinate (row) {
      this.reload = false;
      this.breadList.push('查看下级账号');
      this.searchList[0].placeholder = '账号名、手机号';
      this.$get({
        url: `/role/property/treeSelect/${row.propertyId}`
      }).then(res => {
        this.searchList[1].options = res.data;
      });
      for (let k in this.searchParams) {
        this.searchParams[k] = '';
      }
      this.$get({
        url: this.listApi.url
      }).then(res => {
        this.reload = true;
        this.listApi.url = `/property/user/children/${row.userId}`;
        let temp = this.rowOptList;
        this.rowOptList = this.childRowOptList;
        this.childRowOptList = temp;
      });
    },
    // 切换面包屑
    handleBread (e) {
      if (e === 0 && this.breadList.length === 1) return false;
      if (e === 0) {
        this.reload = false;
        this.breadList = this.breadList.length > 1 ? this.breadList.splice(0, 1) : null;
        this.searchList[0].placeholder = '公司、账号名、手机号';
        for (let k in this.searchParams) {
          this.searchParams[k] = undefined;
        }
        this.$get({
          url: this.listApi.url
        }).then(res => {
          this.reload = true;
          this.listApi.url = '/property/user/list';
          let temp = this.rowOptList;
          this.rowOptList = this.childRowOptList;
          this.childRowOptList = temp;
        });
        this.getSelect();
      }
    },
    // 设为主账号
    setOwnAccount (row) {
      this.title = '设为主账号';
      this.currentRow = row;
      this.visible = true;
    },
    // 账号转移
    accountTransfer (row) {
      this.currentRow = row;
      this.title = '账号转移';
      this.visible = true;
      this.accountList = [];
      this.$get({
        url: '/property/user/treeSelect'
      }).then(res => {
        this.accountList = res.data;
      });
    },
    // 确认事件
    handleOk (e) {
      if (this.title === '设为主账号') {
        this.confirmLoading = true;
        // 替换原主账号
        this.$put({
          url: `/property/user/replace/${this.currentRow.userId}`
        }).then(res => {
          if (res.code === 200) {
            this.reload = false;
            this.visible = false;
            this.confirmLoading = false;
            this.listApi.url = `/property/user/children/${this.currentRow.userId}`;
            this.$message.success(`${res.msg}`).then(() => {
              this.reload = true;
            });
          }
        }).catch(() => {
          this.confirmLoading = false;
        });
      } else {
        if (!this.formKey.parentId) return this.$message.error('请选择主账号');
        if (!this.formKey.roleId) return this.$message.error('请选择角色');
        this.confirmLoading = true;
        if (typeof this.formKey.roleId !== 'string') {
          this.formKey.roleId = this.formKey.roleId.join();
        }
        this.$put({
          url: `/property/user/transfer/${this.currentRow.userId}`,
          params: this.formKey
        }).then(res => {
          this.confirmLoading = false;
          if (res.code === 200) {
            this.reload = false;
            this.visible = false;
            this.title = '';
            for (let k in this.formKey) {
              this.formKey[k] = '';
            }
            this.$message.success(`${res.msg}`).then(() => {
              this.reload = true;
            });
          }
        }).catch(() => {
          this.confirmLoading = false;
        });
      }
    },
    handleChangeSin (value) {
      this.formKey.parentId = value;
      this.roleValue = [];
      this.formKey.roleId = '';
      this.$get({
        url: `/role/property/treeSelect/${value}`
      }).then(res => {
        this.roleList = res.data;
        // this.roleList = [{label: '角色', value: '21'}];
      });
    },
    handleChangeDou (value) {
      this.formKey.roleId = value;
    },
    handleDeselect (value) {
      this.formKey.roleId = value;
    },
    handleCancel () {
      this.visible = false;
      this.title = '';
      this.roleValue = [];
      for (let k in this.formKey) {
        this.formKey[k] = '';
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].elm.textContent.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>

<style lang="less" scoped>
.select-wrap{
  display: flex;
  flex-direction: column;
  .select-box{
    margin: 20px 0 0 13px;
  }
}
</style>
